import { gql } from '@/store/helpers/axios.js'
import { merge, isEmpty } from 'lodash'

export default {
    async GET_FUNDINGS ({ commit }) { // bei Profile: (where: { profiltypId: { eq: 2 } })
      const query = `query cRMFundingProfileV2s (
          $order: [CRMFundingProfileV2SortInput!]
        ) {
            response: cRMFundingProfileV2s (order: $order,
              where: {profile: {profiltypId: { eq: 2}}}) {
            field_001
            closingdate
            privacyJoin
            moneyinCHF
            moneypublic
            statusId
            investmentsTypeId
            investmentsStage
            closingdate
            comment
            datum
            cRMFundingJOINProfilProfileV2s{
              profil_idId
              startupFundingID
              field_001
              profile {
                field_001
                cRM_Adress_id
                cRMAddress {
                  field_001
                  company
                }
              }
            }
            profile {
              field_001
              cRM_Adress_id
              cRMAddress {
                field_001
                company
                kantonId
                technologyId
                firstname
                lastname
                salutationId
                emailB1
                emailB2
                linkedInB
                linkedInP
                cRMBranche {
                  brancheEn
                }
                cONTESTWinners {
                  field_001
                  crm_adress_id
                  contest_execution_idId
                  cONTESTExecution {
                    contest_release
                    cONTESTContest {
                      category_idId
                      contest
                    }
                  }
                }
              }
              pROFILProfilJOINReportingGroups {
                reportingGroupIDId
                pROFILReportingGroup {
                  reportingGroups
                }
              }
              pROFILProfilJOINCategories {
                field_001
                kategorie_idId
                pROFILCategory {
                  field_001
                  kategorieDE
                }
              }
              cRMFundingProfileV2s {
                field_001
                moneyinCHF
                statusId
                investmentsStage
                investmentsTypeId
              }
            }
            cRMFundingInvestmentsStageProfileV2 {
              field_001
              investmentsStage
            }
            cRMFundingInvestmentsTypeProfileV2 {
              field_001
              investmentsType
            }
            cRMFundingStatusProfileV2 {
              field_001
              status
            }
          }
        }`

      /*
      pROFILUntersttzungszuweisungs {
        untersttzungId
      }

      cRMFundingProfileV2s {
        field_001
        statusId
        moneyinCHF
      }
      */

      const variables = {
        order: {
          closingdate: 'DESC'
        }
      }

      const { data } = await gql({ query, variables })

      if (!data.errors) {
        commit('SET_FUNDINGS', data.data.response)
      }

      return data
    },
    async GET_FUNDINGS_PAGINATION ({ commit }, { gqlOptions }) { // bei Profile: (where: { profiltypId: { eq: 2 } })
        const query = `query cRMFundingProfileV2s (
            $order: [CRMFundingProfileV2SortInput!],
            $where: CRMFundingProfileV2FilterInput,
            $take: Int,
            $skip: Int
          ) {
              response: cRMFundingProfileV2s (order: $order, where: $where, take: $take, skip: $skip) {
              items {
                  field_001
                  closingdate
                  privacyJoin
                  moneyinCHF
                  moneypublic
                  statusId
                  investmentsTypeId
                  investmentsStage
                  closingdate
                  comment
                  datum
                  cRMFundingJOINProfilProfileV2s{
                    profil_idId
                    startupFundingID
                    field_001
                    profile {
                      field_001
                      cRM_Adress_id
                      cRMAddress {
                        field_001
                        company
                      }
                    }
                  }
                  profile {
                    field_001
                    profiltypId
                    cRM_Adress_id
                    cRMAddress {
                      field_001
                      company
                      kantonId
                      technologyId
                      firstname
                      lastname
                      salutationId
                      emailB1
                      emailB2
                      linkedInB
                      linkedInP
                      cRMBranche {
                        brancheEn
                      }
                      cONTESTWinners {
                        field_001
                        crm_adress_id
                        contest_execution_idId
                        cONTESTExecution {
                          contest_release
                          cONTESTContest {
                            category_idId
                            contest
                          }
                        }
                      }
                    }
                    pROFILProfilJOINReportingGroups {
                      reportingGroupIDId
                      pROFILReportingGroup {
                        reportingGroups
                      }
                    }
                    pROFILProfilJOINCategories {
                      field_001
                      kategorie_idId
                      pROFILCategory {
                        field_001
                        kategorieDE
                      }
                    }
                    cRMFundingProfileV2s {
                      field_001
                      moneyinCHF
                      statusId
                      investmentsStage
                      investmentsTypeId
                    }
                  }
                  cRMFundingInvestmentsStageProfileV2 {
                    field_001
                    investmentsStage
                  }
                  cRMFundingInvestmentsTypeProfileV2 {
                    field_001
                    investmentsType
                  }
                  cRMFundingStatusProfileV2 {
                    field_001
                    status
                  }
                }
              totalCount
            }
          }`

        const variables = {
          order: {
            closingdate: 'DESC'
          },
          where: {
            profile: { profiltypId: { eq: 2 } }
          }
        }

        if (!isEmpty(gqlOptions.order)) {
          variables.order = {}
        }

        const combinedVariables = merge(variables, gqlOptions)

        const { data } = await gql({ query, variables: combinedVariables })

        return data
    },
    async GET_FUNDING_BY_ID ({ commit }, { id }) {
        const query = `query cRMAddress ($id: Int!) {
          response: cRMAddress (field_001: $id) {
              field_001
              profiles (where: { profiltypId: { eq: 2 } }) {
                field_001
                profiltypId
                cRMFundingProfileV2s {
                  field_001
                  datum
                  closingdate
                  comment
                  moneyinCHF
                  statusId
                  cRMFundingJOINProfilProfileV2s{
                    field_001
                    profil_idId
                    startupFundingID
                    profile {
                      field_001
                      cRM_Adress_id
                      cRMAddress {
                        field_001
                        company
                      }
                    }
                  }
                }
              }
          }
        }`

        const variables = {
            id: Number(id)
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_FUNDINGS_DETAIL', data.data.response)
        }

        return data
    },
    async GET_COMPANIES ({ commit }, formData) {
        const query = `query cRMAddresses (
          $where: CRMAddressFilterInput
          $order: [CRMAddressSortInput!]
        ) {
          response: cRMAddresses (order: $order, where: $where) {
            field_001
              company
              firstname
              lastname
              cRMAdresseJOINRolles (where: { or: [{ rolle_id: { eq: 26 } }, { rolle_id: { eq: 17 } }]}) {
                field_001
                rolle_id
                crm_adress_id
              }
              profiles (where: { profiltypId: { eq: 2 } }) {
                field_001
                profiltypId
                cRMFundingProfileV2s {
                  field_001
                  closingdate
                }
              }
          }
        }`

        const variables = {
            order: {
              company: 'ASC'
            },
            where: {
              company: { contains: formData }
            }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_COMPANIES', data.data.response)
        }

        return data
    },
    async GET_COMPANY_NAMES ({ commit }) {
        const query = `query cRMAddresses (
          $order: [CRMAddressSortInput!]
        ) {
          response: cRMAddresses (order: $order) {
            field_001
            company
          }
        }`

        const variables = {
            order: {
              company: 'ASC'
            }
        }

        const { data } = await gql({ query, variables })
        if (!data.errors) {
          const companyArray = []
          for (const company of data.data.response) {
            if (!companyArray.includes(company.company)) {
              if (company.company !== null && company.company !== '') {
                companyArray.push(company.company)
              }
            }
          }
          commit('SET_COMPANY_NAMES', companyArray)
        }

        return data
    },
    async UPDATE_ADDRESS ({ commit }, { id, formData }) {
        const {
          field_001, /* eslint-disable-line */
          company,
          kantonId,
          technologyId,
          firstname,
          lastname,
          salutationId,
          emailB1,
          emailB2,
          linkedInB,
          linkedInP
        } = formData

        const query = `mutation updateCRMAddress($input: UpdateCRMAddressInput!) {
          updateCRMAddress(input: $input) {
            cRMAddress {
              field_001
            }
            errors {
              code
              field
              i18nKey
              message
            }
          }
        }`

        const variables = {
          input: {
            field_001,
            company,
            kantonId,
            technologyId,
            firstname,
            lastname,
            salutationId,
            emailB1,
            emailB2,
            linkedInB,
            linkedInP
          }
        }

        const { data } = await gql({ query, variables })

        return data
    },
    async UPDATE_FUNDING_PROFILE ({ commit }, { formData }) {
        const {
          field_001, /* eslint-disable-line */
          investmentsTypeId,
          statusId,
          moneyinCHF,
          investmentsStage,
          closingdate,
          privacyJoin
        } = formData

        const query = `mutation updateCRMFundingProfileV2 ($input: UpdateCRMFundingProfileV2Input!) {
          updateCRMFundingProfileV2(input: $input) {
            cRMFundingProfileV2 {
              field_001
            }
            errors {
              code
              field
              i18nKey
              message
            }
          }
        }`

        const variables = {
          input: {
            field_001,
            investmentsTypeId,
            statusId,
            moneyinCHF,
            investmentsStage,
            closingdate,
            privacyJoin
          }
        }

        const { data } = await gql({ query, variables })

        return data
    },
    async GET_FUNDINGS_BY_REPORTINGGROUP ({ commit }, rgId) {
        const query = `query pROFILProfilJOINReportingGroups (
            $order: [PROFILProfilJOINReportingGroupSortInput!]
            $where: PROFILProfilJOINReportingGroupFilterInput
          ) {
              response: pROFILProfilJOINReportingGroups (order: $order, where: $where) {
              field_001
              profil_id
              reportingGroupIDId
              profile {
                field_001
                cRM_Adress_id
                profiltypId
                totalEmployee
                cRMFundingProfileV2s {
                  field_001
                  startup_profil_id
                  closingdate
                  moneyinCHF
                  moneypublic
                  statusId
                  investmentsTypeId
                  investmentsStage
                  cRMFundingInvestmentsStageProfileV2 {
                    field_001
                    investmentsStage
                  }
                }
              }
            }
          }`

        const variables = {
          where: {
            reportingGroupIDId: { eq: rgId },
            profile: { profiltypId: { eq: 2 } }
          }
        }

        const { data } = await gql({ query, variables })

        if (!data.errors) {
          commit('SET_FUNDINGS_BY_RG', data.data.response)
        }

        return data
      },
      async GET_FUNDINGS_BY_RG_DETAIL ({ commit }, gqlOptionsFilter) {
        const {
          gqlOptions,
          rgId,
          stageFilter
        } = gqlOptionsFilter
        const query = `query cRMFundingProfileV2s (
            $order: [CRMFundingProfileV2SortInput!],
            $where: CRMFundingProfileV2FilterInput,
            $take: Int,
            $skip: Int
          ) {
              response: cRMFundingProfileV2s (order: $order, where: $where, take: $take, skip: $skip) {
              items {
                  field_001
                  closingdate
                  privacyJoin
                  moneyinCHF
                  moneypublic
                  statusId
                  investmentsTypeId
                  investmentsStage
                  closingdate
                  comment
                  datum
                  pROFILProfilJOINReportingGroups {
                    field_001
                    profil_id
                    reportingGroupIDId
                  }
                  cRMFundingJOINProfilProfileV2s{
                    profil_idId
                    startupFundingID
                    field_001
                    profile {
                      field_001
                      cRM_Adress_id
                      cRMAddress {
                        field_001
                        company
                      }
                    }
                  }
                  profile {
                    field_001
                    profiltypId
                    cRM_Adress_id
                    acquiredBy
                    cRMAddress {
                      field_001
                      company
                      kantonId
                      technologyId
                      firstname
                      lastname
                      salutationId
                      emailB1
                      emailB2
                      linkedInB
                      linkedInP
                      cRMBranche {
                        brancheEn
                      }
                      cONTESTWinners {
                        field_001
                        crm_adress_id
                        contest_execution_idId
                        cONTESTExecution {
                          contest_release
                          cONTESTContest {
                            category_idId
                            contest
                          }
                        }
                      }
                    }
                    pROFILProfilJOINReportingGroups {
                      reportingGroupIDId
                      pROFILReportingGroup {
                        reportingGroups
                      }
                    }
                    pROFILProfilJOINCategories {
                      field_001
                      kategorie_idId
                      pROFILCategory {
                        field_001
                        kategorieDE
                      }
                    }
                    cRMFundingProfileV2s {
                      field_001
                      moneyinCHF
                      statusId
                      investmentsStage
                      investmentsTypeId
                    }
                  }
                }
              totalCount
            }
          }`

        const variables = {
          order: {
            closingdate: 'DESC'
          },
          where: {
            statusId: { eq: 2 },
            profile: { profiltypId: { eq: 2 } },
            pROFILProfilJOINReportingGroups: { some: { reportingGroupIDId: { eq: rgId } } },
            investmentsStage: { eq: stageFilter }
          }
        }

        if (!isEmpty(gqlOptions.order)) {
          variables.order = {}
        }

        const combinedVariables = merge(variables, gqlOptions)

        const { data } = await gql({ query, variables: combinedVariables })

        return data
    }
}
